<template>
  <div class="overview-fields-setting">
    <div class="list">
      <div class="title">显示的字段</div>
      <div class="empty" v-if="showFields.length == 0">暂无数据</div>
      <draggable
        v-else
        group="tile"
        v-model="showFields"
        :animation="100"
        @change="showFieldsChange"
      >
        <row v-for="(field, index) in showFields" :key="index" drag-flag>
          <template v-slot:prefix>
            <svg-icon icon-class="svgo_drag"></svg-icon>
          </template>
          {{ field.name }}
          <template v-slot:suffix>
            <el-tooltip effect="dark" content="隐藏" placement="bottom">
              <span class="expand" @click="removeFromShowFields(field, index)">
                <svg-icon icon-class="svgo_hide"></svg-icon>
              </span>
            </el-tooltip>
          </template>
        </row>
      </draggable>
    </div>

    <div class="list">
      <div class="title">隐藏的字段</div>
      <div class="empty" v-if="hideFields.length == 0">暂无数据</div>
      <template v-else>
        <div class="search-box">
          <el-input v-model="searchText" placeholder="字段名称" clearable>
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <row v-for="(field, index) in canHideFields" :key="index" style="padding-left: 14px">
          {{ field.name }}
          <template v-slot:suffix>
            <el-tooltip effect="dark" content="显示" placement="bottom">
              <i
                class="el-icon-view expand"
                style="font-weight: bold"
                @click="addToShowFields(field, index)"
              ></i>
            </el-tooltip>
          </template>
        </row>
      </template>
    </div>
  </div>
</template>

<script>
import Row from "@/components/BaseComponents/Panel/Row"
import draggable from "vuedraggable"

export default {
  name: "overview-fields-setting",
  components: {
    draggable,
    Row
  },
  data() {
    return {
      searchText: "",
      showFields: [],
      hideFields: []
    }
  },
  props: {
    fields: Array,
    overviewFields: Array
  },
  computed: {
    canHideFields() {
      if (!this.searchText) return this.hideFields
      return this.hideFields.filter(field => field.name.includes(this.searchText))
    }
  },
  methods: {
    // 初始化
    init() {
      this.showFields = this.overviewFields
      let overviewCids = this.overviewFields.map(i => i._cid)
      this.fields.forEach(field => {
        if (field._type !== "chart" && !overviewCids.includes(field._cid))
          this.hideFields.push(field)
      })
    },
    // 添加到显示的字段
    addToShowFields(field, index) {
      if (this.showFields.length >= 6) return this.$message.error("摘要中最多添加6个字段!")
      this.showFields.push(field)
      this.hideFields.splice(index, 1)
      this.output()
    },
    // 从显示的字段中移除
    removeFromShowFields(field, index) {
      this.hideFields.push(field)
      this.showFields.splice(index, 1)
      this.output()
    },
    // 显示的字段顺序发生变化
    showFieldsChange(evt) {
      if (evt.moved) this.output()
    },
    // 输出摘要信息
    output() {
      this.$emit("update", {
        dataType: "overviewFields",
        data: this.showFields
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.overview-fields-setting {
  overflow: hidden;
  margin-top: 14px;
  .empty {
    text-align: center;
    height: 40px;
    line-height: 40px;
    color: #757575;
    font-size: 13px;
  }
  .list {
    margin-bottom: 14px;
    .title {
      margin-bottom: 12px;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .search-box {
    margin-bottom: 10px;
    ::v-deep .el-input-group__append {
      padding: 0 16px;
    }
  }
  .expand {
    vertical-align: middle;
    padding: 6px;
  }
}
</style>
